import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User | null | undefined
}

export default function CommonEmployeeLabel({ user }: Props) {
  if (!user) return null

  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <UserAvatar size="s32" user={user} />
      <Text.Normal>{user.fullName()}</Text.Normal>
    </Box>
  )
}
